__turbopack_context__.v({
  "container": "DoYouHaveWarehouseBlock-module-scss-module__fY-WHW__container",
  "description": "DoYouHaveWarehouseBlock-module-scss-module__fY-WHW__description",
  "title": "DoYouHaveWarehouseBlock-module-scss-module__fY-WHW__title",
});
